import moment from 'moment';
import { ContentPlanOutputMix } from '../../../queries/Admin/Calendar/useAdminContentNotesGenerateMutation';

export type { ContentPlanOutputMix };

// Labels are per month, not per plan - the plan length is chosen separately.
export const OUTPUT_MIX_OPTIONS: { value: ContentPlanOutputMix; label: string }[] = [
	{ value: 'EmailAndSocial', label: '1 email + 3 social per month' },
	{ value: 'EmailOnly', label: '2 emails per month' },
	{ value: 'SocialOnly', label: '4 social per month' },
	{ value: 'SocialAndBlogs', label: '1 blog + 3 social per month' },
	{ value: 'EmailAndBlogs', label: '1 email + 2 blogs per month' },
];

/** Matches ContentPlanSpec.MaxMonthCount on the API, which clamps anything larger. */
export const MAX_MONTH_COUNT = 6;

export const DEFAULT_MONTH_COUNT = 3;

export const MONTH_COUNT_OPTIONS = Array.from({ length: MAX_MONTH_COUNT }, (_, index) => {
	const count = index + 1;
	return { value: String(count), label: count === 1 ? '1 month' : `${count} months` };
});

const START_MONTH_CHOICES = 12;

// Starts at the current month so a plan can cover the month the meeting happened in.
export function buildStartMonthOptions(from: Date = new Date()): { value: string; label: string }[] {
	const start = moment(from).startOf('month');
	return Array.from({ length: START_MONTH_CHOICES }, (_, offset) => {
		const month = start.clone().add(offset, 'months');
		return { value: month.format('YYYY-MM'), label: month.format('MMMM YYYY') };
	});
}

export function defaultStartMonth(from: Date = new Date()): string {
	return moment(from).startOf('month').format('YYYY-MM');
}
